const quotes = [
  "We believe that every investment deserves the power of precision. That’s why Perceive Now delivers actionable insights tailored to your needs—when you need them",
  "Our promise is clarity in complexity. Perceive Now simplifies the overwhelming, delivering insights that guide your next big move.",
  "We’re here to bridge the gap between raw data and actionable strategy, transforming how you perceive opportunities and risks.",
  "You make the decisions; we ensure they’re powered by insights that are accurate, timely, and relevant to your goals.",
];

export default quotes;